<template>
  <div v-if="report" class="report-columns">
    <div class="toolbar">
      <h5>{{ report.name || report.report_type.name }} Columns</h5>
      <hr />
    </div>

    <q-spinner v-if="!report" color="primary" size="2.5em" />

    <div v-else class="content">
      <div class="header">
        <q-input
          ref="filter"
          v-model="filter"
          filled
          dense
          class="col-12"
          label="Filter columns"
          @keydown.esc="filter = null"
        >
          <template v-slot:append>
            <q-icon v-if="filter" name="clear" class="cursor-pointer" @click="resetFilter" />
          </template>
        </q-input>
      </div>

      <div class="columns">
        <q-tree
          :nodes="nodes"
          :ticked.sync="ticked"
          :filter="filter"
          :filter-method="filterColumns"
          no-results-label="No matching columns found"
          default-expand-all
          class="col-12"
          node-key="id"
          tick-strategy="leaf"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { orderBy } from 'lodash'

export default {
  data() {
    return {
      filter: null,
      ticked: []
    }
  },

  computed: {
    ...mapState('reports', ['newReport', 'reportToEdit', 'routerView']),

    report() {
      if (this.routerView === 'newReportPage') return this.newReport
      if (this.routerView === 'editReportPage') return this.reportToEdit
      return null
    },

    nodes() {
      if (!this.report) return
      let columns = []
      if (this.routerView === 'newReportPage') {
        columns = this.report.column_categories
      } else {
        columns = this.report.columns.all_columns
      }

      return columns.reduce((acc, curr) => {
        const columns = curr.columns.map(col => ({
          label: col.name,
          id: col.id,
          order_column: col.order_column
        }))
        const columnCategory = {
          id: `${curr.name}`,
          label: curr.name,
          children: orderBy(columns, 'order_column')
        }
        acc.push(columnCategory)
        return acc
      }, [])
    }
  },

  watch: {
    ticked: 'setVisibleColumns',
    $route: {
      handler: 'setSelectedColumns',
      immediate: true
    }
  },

  methods: {
    ...mapMutations('reports', ['setVisibleColumns']),

    setSelectedColumns() {
      const view = this.routerView
      if (!this.report) return
      if (view === 'newReportPage') {
        this.ticked = this.newReport.preselected_columns
      } else {
        this.ticked = this.reportToEdit.columns.selected_col_ids
      }
    },

    filterColumns(node, filter) {
      const filterText = filter.toLowerCase()
      return node.label && node.label.toLowerCase().indexOf(filterText) > -1
    },

    resetFilter() {
      this.filter = ''
      this.$refs.filter.focus()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

.report-columns {
  border 1px solid #e4dddd
  border-top none
  padding 10px
  text-align center
  display grid
  grid-template-rows 50px 1fr
  height 100%

  styledScrollFor('.content')

  .content {
    display grid
    grid-template-rows 50px 1fr
    overflow auto

    .header {
      align-self center
    }
  }
}
</style>
